const categories = [
	{
		path: '/tv/categories/list',
		name: 'tv-categories-list',
		component: () => import('@/views/tv/categories/list.vue'),
		meta: {
			layout: 'content',
			module: 'MGTV,categories',
		},
	},
]

export default categories
